import { CreatedColumns, UpdatedColumns } from '../common.columns';
import {
  EquipmentCategory,
  EquipmentFuelType,
  EquipmentLocationType,
  EquipmentOwnershipType,
  EquipmentStatus,
  EquipmentType,
} from './equipment.enums';

/** Fields that backend sends as Decimal strings for Equipment */
export const EQUIPMENT_DECIMAL_FIELDS = new Set<string>([
  'purchase_price',
  'current_value',
  'operating_hours',
  'fuel_capacity',
  'engine_hours',
  'service_interval_hours',
  'service_interval_months',
  'latitude',
  'longitude',
]);

export interface Equipment extends CreatedColumns, UpdatedColumns {
  id?: string;
  farm_id: string;
  name: string;

  // Basic information
  type: EquipmentType;
  category: EquipmentCategory;
  status: EquipmentStatus;

  // Equipment details
  make: string;
  model: string;
  year?: number;
  serial_number?: string;

  // Financial information
  purchase_date?: string;
  purchase_price?: number;
  current_value?: number;

  // Location information
  location_type: EquipmentLocationType;
  location_id?: string;
  latitude?: number;
  longitude?: number;
  location_note?: string;

  // Operating information
  operating_hours?: number;
  fuel_type?: EquipmentFuelType;
  fuel_capacity?: number;
  engine_hours?: number;

  // Maintenance information
  last_service_date?: string;
  next_service_due?: string;
  service_interval_hours?: number;
  service_interval_months?: number;
  warranty_expiry?: string;
  insurance_expiry?: string;

  // Registration and identification
  registration_number?: string;
  vin?: string;
  insurance_policy_id?: string;

  // Field activity integration
  auto_log_hours?: boolean;
  gps_tracking_enabled?: boolean;
  last_field_activity?: string;

  notes?: string;

  // Ownership information
  ownership_type?: EquipmentOwnershipType;

  // Joined fields (optional)
  maintenance_records_count?: number;
  overdue_maintenance?: boolean;
}

